import formatContent from '@/modules/list/config/formatters/content';
import formatCategory from '@/modules/list/config/formatters/category';
import formatBoard from '@/modules/list/config/formatters/board';
import formatStaff from '@/modules/list/config/formatters/staff';
import formatSocialNetworkAccount from '@/modules/list/config/formatters/social';
import formatDefaultEntity from '@/modules/list/config/formatters/default';
import { formatAdMap, formatAdPosition } from '@/modules/list/config/formatters/ads';

export function makeFormatter(entity) {
  const formatters = {
    content: formatContent,
    category: formatCategory,
    board: formatBoard,
    user: formatDefaultEntity,
    staff: formatStaff,
    socialNetworkAccount: formatSocialNetworkAccount,
    adPosition: formatAdPosition,
    adMap: formatAdMap,
    geo: formatCategory,
    default: item => formatDefaultEntity(item, entity),
  };
  const formatter = formatters[entity];
  if (!formatter) {
    return formatters.default;
  }
  return formatter;
}

// Legacy support for old lists configured in sites
export const availableViews = {
};

export default {
  availableViews,
};
